import axios from 'axios';

import tokenHelper from '../helpers/token';
import {
	api,
	apiAuth,
	setToken,
	removeToken,
	generateTokenStructure,
	requestConfig,
} from './index';

import authParams from './authParams';

export const userCheckAccount = async (mobile) => {
	try {
		const { data } = await api.post('user/login', {
			...authParams,
			username: mobile,
		});

		return { userExist: data.userStateId === 1 };
	} catch (e) {
		throw e;
	}
};

export const userLogin = async (mobile, password) => {
	try {
		const { data } = await api.post('token/createToken', {
			...authParams,
			username: mobile,
			password,
		});
		setToken(data.token, data.refreshToken);

		return data;
	} catch (e) {
		throw e;
	}
};

export const userVerifyMobile = async (mobile, confirmationCode) => {
	try {
		const { data } = await api.post('user/confirmCode', {
			...authParams,
			username: mobile,
			confirmationCode,
		});
		return data;
	} catch (e) {
		throw e;
	}
};

export const userForgetPassword = async (mobile) => {
	try {
		const { data } = await api.post('user/forgetPassword', {
			...authParams,
			username: mobile,
		});

		return data;
	} catch (e) {
		throw e;
	}
};

export const userResetPassword = async (newPassword, tokenData) => {
	const instanceApi = axios.create(requestConfig);
	instanceApi.defaults.headers.common.Authorization = generateTokenStructure(
		tokenData.token,
	);

	try {
		const { data } = await instanceApi.put('user/setPassword', {
			...authParams,
			newPassword,
		});

		setToken(tokenData.token, tokenData.refreshToken);

		return data;
	} catch (e) {
		throw e;
	}
};

export const userLogout = async () => {
	try {
		const tokenData = await tokenHelper.get();

		const { data } = await apiAuth.post('token/logout', {
			...authParams,
			refreshToken: tokenData.refreshToken,
		});

		removeToken();
		return data;
	} catch (e) {
		throw e;
	}
};
